import { assertNotEmpty } from '@festina-life/core'

import {
  isConfigurationFunction,
  isSimpleTemplateField,
  type SimpleTemplateField,
} from '../../types/templateModel'
import { AddDynamicFunctionCell } from '../dynamicFunction/AddDynamicFunctionCell'
import {
  type AddDynamicFunctionPlaceholder,
  isAddDynamicFunctionPlaceholder,
} from '../dynamicFunction/types'
import { SpecialCasedSubTemplatedFieldValueCell } from '../specialCasedSubTemplatedViewers/SpecialCasedSubTemplatedFieldValueCell'
import {
  isSpecialCasedSubTemplatedValueSetup,
  type SpecialCasedSubTemplatedValueSetup,
} from '../specialCasedSubTemplatedViewers/types'
import type { ConfigurationTemplateFunctionValueWithPosition } from './fieldsHelpers'
import { TemplateFieldCell } from './TemplateFieldCell'
import { TemplateFunctionCell } from './TemplateFunctionCell'

type Props = {
  data:
    | SimpleTemplateField
    | ConfigurationTemplateFunctionValueWithPosition
    | SpecialCasedSubTemplatedValueSetup
    | AddDynamicFunctionPlaceholder
  column: number
  row?: number
}

export const ChildFieldTableCell = ({ data, column, row }: Props) => {
  if (isSpecialCasedSubTemplatedValueSetup(data)) {
    return (
      <SpecialCasedSubTemplatedFieldValueCell data={data} column={column} />
    )
  } else if (isAddDynamicFunctionPlaceholder(data)) {
    assertNotEmpty(data.parent)

    return <AddDynamicFunctionCell {...data} column={column} />
  } else if (isConfigurationFunction(data)) {
    return <TemplateFunctionCell column={column} row={row} data={data} />
  } else if (isSimpleTemplateField(data)) {
    return (
      <TemplateFieldCell
        field={data}
        isHeaderRow={!row && row !== 0}
        column={column}
      />
    )
  } else {
    throw new Error(`Unsupported field type ${data}`)
  }
}
